/* The five worlds — one fictional Valessio, five moments of its life.
   Deterministic by construction; switching worlds re-seeds everything. */
export const WORLDS = ['day-one', 'week-two', 'cruising', 'nine-locations', 'everything-wrong'] as const
export type World = typeof WORLDS[number]
export const WORLD_LABELS: Record<World, string> = {
  'day-one': 'Jour 1', 'week-two': 'Semaine 2', 'cruising': 'Rythme de croisière',
  'nine-locations': '9 établissements', 'everything-wrong': 'Tout va mal',
}
/** I-1 (i1-b-vet point 1) · Version 19's state: each world's first live campaign (its lowest seq) is the « campagne
 *  principale » of its establishment(s): « Rentrée 2026 » (c1) at Paris 9 in week-two, cruising and nine-locations. Day one
 *  has no campaign; in everything-wrong it is paused, so none is live. A world keeps its own choice once made
 *  (bmr.principal.<world>; `{}` there = none, for a check that needs no principale); the mock server seeds from it. */
export const SEED_PRINCIPALS: Record<World, Record<string, string>> = {
  'day-one': {}, 'week-two': { l0: 'c1' }, 'cruising': { l0: 'c1' }, 'nine-locations': { l0: 'c1' }, 'everything-wrong': {},
}
const KEY = 'bmr.world'
export function currentWorld(): World {
  /* ?monde= lets a link land in a specific world (review deep links, demos).
     It persists like a switcher click, so navigation stays in that world. */
  try {
    const q = new URLSearchParams(location.search).get('monde') as World | null
    if (q && WORLDS.includes(q)) {
      try { localStorage.setItem(KEY, q) } catch { /* non-persistent is fine */ }
      return q
    }
  } catch { /* no URL access — fall through */ }
  try {
    const w = localStorage.getItem(KEY) as World | null
    if (w && WORLDS.includes(w)) return w
  } catch { /* default below */ }
  return 'cruising'
}
export function setWorld(w: World): void {
  try { localStorage.setItem(KEY, w) } catch { /* non-persistent is fine */ }
  location.reload()
}
